export default function (props: any) {
    return (
        <svg width="39px" height="38px" viewBox="0 0 39 38" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="DELTA-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Laptop_icon" transform="translate(0.440662, 0.000000)">
                    <rect id="矩形" x="0" y="0" width="38" height="38"></rect>
                    <g id="编组-37" transform="translate(2.830151, 7.037960)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                        <path
                            d="M2.15874768,19.8943293 L2.15874768,1.53095926 C2.15874768,0.685568099 2.81706108,0 3.62935147,0 L28.6184999,0 C29.4307903,0 30.0891037,0.685568099 30.0891037,1.53095926 L30.0891037,19.8943293"
                            id="Stroke-147"
                            strokeWidth="1.18998886"
                        ></path>
                        <path
                            d="M31.8456534,23.924079 L0.494043827,23.924079 C0.221084612,23.924079 0,23.6939852 0,23.4099029 L2.15874768,20.1846383 L30.1266765,20.1846383 L32.3396972,23.4099029 C32.3396972,23.6939852 32.1186126,23.924079 31.8456534,23.924079 Z"
                            id="Stroke-148"
                            strokeWidth="1.18998886"
                        ></path>
                        <line x1="15.6790629" y1="1.99867027" x2="17.0928271" y2="1.99867027" id="路径-6" strokeWidth="1.34104007"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}
